export default "__VITE_ASSET__cca7d958__"